import React, { CSSProperties, PropsWithChildren } from "react";
import { extractIntercomArticleId } from "@shared/utils/misc";
import Link from "common/Typography/Link";
import { showIntercomArticle } from "utils/misc.tsx";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";
import { useBranding } from "@shared/utils/hooks/useBranding";

interface IntercomLinkProps {
  articleId?: string;
  articleLink?: string;
  style?: CSSProperties;
  className?: string;
}

const IntercomLink = ({
  articleId: propsArticleId,
  articleLink,
  style,
  children,
  className,
}: PropsWithChildren<IntercomLinkProps>) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.COMMON);
  const { isWhitelabel } = useBranding();

  const getArticleId = () => {
    if (propsArticleId) return propsArticleId;
    else if (articleLink) return extractIntercomArticleId(articleLink);
  };

  const articleId = getArticleId();
  const onPress = () => {
    if (articleId) {
      showIntercomArticle(articleId);
    }
  };

  if (isWhitelabel) return null;

  return (
    <Link onClick={onPress} style={style} className={className}>
      {children || t("labels.learn_more")}
    </Link>
  );
};

export default IntercomLink;
